import Vue from 'vue'
import Vuex from 'vuex'

import { corona } from "./corona"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
      //corona
  }
})
